import { render } from "./Stock_Adjustment_Details.vue?vue&type=template&id=af6f19c0"
import script from "./Stock_Adjustment_Details.vue?vue&type=script&lang=js"
export * from "./Stock_Adjustment_Details.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__